import React from "react";
import ReactDOM from "react-dom/client";
import { SuperAdminAuthProvider } from "./auth/SuperAdminAuthProvider";
import { App } from "./App";
import "./styles.css";
import { initSentry } from "@cafe-os/observability";

// Super-Admin использует Hospitality Warm тему (бренд платформы).
if (typeof document !== "undefined") {
  document.documentElement.dataset.theme = "hospitality-warm";
}

// Sentry error monitoring.
initSentry({ app: "super-admin" });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SuperAdminAuthProvider>
      <App />
    </SuperAdminAuthProvider>
  </React.StrictMode>,
);
